import store from 'store2'

import post from '../../../lib/post'

export default function(roll,start){

  var ombStore = store.namespace('omb')

  post(
    'data',
    {
      token: ombStore('token'),
      type: 'snippet',
      roll: roll,
      start: start,
    },
    function(){
      console.log('snippet generated',roll,start)
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/generateSnippet.js